import { render, staticRenderFns } from "./UploadedFilesView.vue?vue&type=template&id=60e2f452&scoped=true&"
import script from "./UploadedFilesView.vue?vue&type=script&lang=ts&"
export * from "./UploadedFilesView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e2f452",
  null
  
)

export default component.exports